export enum IntellisenseErrorMessage {
  AggregateNoColumnSpecified = 'No column in aggregate function specified',
  InvalidAggregateFunction = 'Invalid aggregate function',
  InvalidExpression = 'Invalid expression',
  MissingSchemaInfo = 'Missing schema information',
}
